import { page_initial_data } from "../../../Page/reducer";
import * as CURRENT_CLIP_CONSTANTS from "../../../../actions/Video/CurrentClip/constants";
import { hasVideoKeyInPayload } from "../../util";

export const initialState = {};

export default function extractCurrentClip(action) {
    switch (action.type) {
        case page_initial_data.type:
            if (!hasVideoKeyInPayload(action.payload, "clip"))
                return initialState;

            return action.payload.video.data.clip;
        case CURRENT_CLIP_CONSTANTS.VIDEO_CURRENT_CLIP_UPDATE:
            return action.payload;
        case CURRENT_CLIP_CONSTANTS.VIDEO_CURRENT_CLIP_NULL:
            return initialState;
        default:
            // Nothing to see here, move along.
            return;
    }
}
